import { CustomerDetailApi } from '../customer-detail/api/customer-detail-api';
import { CustomerListApi } from '../customer-list/api/customer-list-api';

export class CustomerApi {
    constructor(protected baseUrl: string) {
        this.CustomerList = new CustomerListApi(this.baseUrl);
        this.CustomerDetail = new CustomerDetailApi(this.baseUrl);
    }

    public CustomerList: CustomerListApi;
    public CustomerDetail: CustomerDetailApi;
}
